import { PropsWithChildren, useEffect, useState } from "react";
import { useServices, useStore } from "../../../hooks";
import { showErrorNotification } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { FormLayout } from "@qpd-reestr/layout";

/**
 * Декоратор ПДН
 */
const ConsentDecorator: React.FC<PropsWithChildren> = (props) => {

    const { userStore } = useStore();
    
    const { consentService } = useServices();
    
    const navigate = useNavigate();
    
    /**
     * Признак, указывающий было ли загружено согласие было получено с сервера
     */
    const [ consentIsLoaded, setConsentIsLoaded ] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            try {
                
                const consent = await consentService.getUserConsent();
                if (!consent) 
                {
                    //если найден скоуп полного доступа, значит токен неверный. Меняем токен
                    const { accessToken, refreshToken } = await consentService.getNoConsentToken();
                    userStore.Authorize(accessToken, refreshToken);
                }

                userStore.hasConsent = consent;

                setConsentIsLoaded(true);
                
            } catch (error: any) {
                showErrorNotification(error);
                navigate("/")
            }
        })();
    }, [consentService, userStore, userStore.hasConsent]);

    if (!consentIsLoaded) return <FormLayout registrarKey={process.env.REACT_APP_REGISTRAR_KEY ?? ""}></FormLayout>;

    // отдаем все вложенные роуты
    return <>{props.children}</>;
}

export default ConsentDecorator;